import { Injectable } from "@angular/core";
import {
  IFillToleranceService,
  CHANNEL_FILL_TOLERANCE_SERVICE,
  DetailFillToleranceResponse,
} from "../IFillToleranceService";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { BaseReplicaActionService } from "./BaseReplicaActionService";
import { Subject } from "rxjs";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { FillOrderData } from "../../model/core/FillOrderData";
import { FillTolerancePromiseService } from "./FillTolerancePromiseService";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class FillToleranceReplicaService
  extends FillTolerancePromiseService
  implements IFillToleranceService
{
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    super();
    this.broker = this.factory.createMessageBroker(CHANNEL_FILL_TOLERANCE_SERVICE, true, true);
  }

  checkQuickFillTolerance(orders: Array<CubiqTS.OrderDataImpl>): Promise<any> {
    let request = new UiArguments("checkQuickFillTolerance");
    let arg1 = new FnArg(orders, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }
  checkDetailFillTolerance(
    fillorderData: Array<FillOrderData>,
  ): Promise<DetailFillToleranceResponse> {
    let request = new UiArguments("checkDetailFillTolerance");
    let arg1 = new FnArg(fillorderData, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  // quickFillOrders(orderIds: Array<string>, stpRequirement: CubiqTS.FillStpRequirement): Promise<any> {
  //     let request = new UiArguments('quickFillOrders');
  //     let arg1 = new FnArg(orderIds, PRIMITIVE);
  //     let arg2 = new FnArg(stpRequirement, PRIMITIVE);
  //     request.args = [arg1, arg2];

  //     return this.broker.runOnService(request, PRIMITIVE);
  // }
}
